import { IconName } from "@elearning-platform/ui";

import { ReactComponent as ModuleIcon } from "../../images/dashboard.svg";

export const Config = {
  moduleName: "dashboard",
  dependencies: [],
  label: "dashboard.pageTitle",
  Icon: ModuleIcon,
  urls: ["/pulpit", "/"],
  routeName: "api_dashboard",
  routes: {},
  options: {},
  theme: {
    welcomeMessage: {
      backgroundColor: "",
      hostBodyColor: "",
    }
  },
  modernIconName: IconName.PageDashboard,
};
